var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNolocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3874_1668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.16156 4.1535C2.70656 4.6085 2.70656 5.3435 3.16156 5.7985L6.04323 8.68016C5.9149 9.27516 5.83323 9.88183 5.83323 10.5002C5.83323 15.3652 10.9899 22.0735 13.1016 24.6285C13.5682 25.1885 14.4199 25.1885 14.8866 24.6285C15.6449 23.7185 16.7766 22.2835 17.9316 20.5918L21.0232 23.6835C21.4782 24.1385 22.2132 24.1385 22.6682 23.6835C23.1232 23.2285 23.1232 22.4935 22.6682 22.0385L4.80656 4.1535C4.35156 3.6985 3.61656 3.6985 3.16156 4.1535ZM13.9999 2.3335C11.8532 2.3335 9.91656 3.16183 8.45823 4.5035L12.1799 8.22516C12.6816 7.8285 13.3116 7.5835 13.9999 7.5835C15.6099 7.5835 16.9166 8.89016 16.9166 10.5002C16.9166 11.1885 16.6716 11.8185 16.2632 12.3202L20.4049 16.4618C21.4316 14.4202 22.1666 12.3318 22.1666 10.5002C22.1666 5.98516 18.5149 2.3335 13.9999 2.3335Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3874_1668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNolocation);
export default __webpack_public_path__ + "static/media/nolocation.e2698e5c891e01f56da589ebd8c106f9.svg";
export { ForwardRef as ReactComponent };